import { AppstoreOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNavigationGroup, navigationGroups } from '@/config/navigation';
import { useNavigationStore } from '@/stores/navigation-store';
import { preloadRouteModule } from '@/app/route-modules';

const { useBreakpoint } = Grid;

export function TopNavigation() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const openTab = useNavigationStore((state) => state.openTab);
  const activeGroup = getNavigationGroup(location.pathname);
  const currentGroup = navigationGroups.find((group) => group.key === activeGroup) ?? navigationGroups[0]!;

  if (screens.xl === false) {
    return (
      <Dropdown
        trigger={['click']}
        menu={{
          selectedKeys: [activeGroup],
          items: navigationGroups.map((group) => ({
            key: group.key,
            icon: group.icon,
            label: <span onPointerEnter={() => { void preloadRouteModule(group.defaultPath); }}>{t(group.titleKey)}</span>,
          })),
          onClick: ({ key }) => {
            const target = navigationGroups.find((group) => group.key === key);
            if (target) {
              openTab(target.defaultPath);
              navigate(target.defaultPath);
            }
          },
        }}
      >
        <Button
          type="text"
          className="top-navigation-compact"
          aria-label={`${t('navigation.moduleMenu')}：${t(currentGroup.titleKey)}`}
        >
          <AppstoreOutlined />
          <span className="tablet-only">{t(currentGroup.titleKey)}</span>
          <DownOutlined />
        </Button>
      </Dropdown>
    );
  }

  return (
    <nav className="top-navigation" aria-label={t('navigation.moduleMenu')}>
      {navigationGroups.map((group) => (
        <button
          key={group.key}
          type="button"
          className={group.key === activeGroup ? 'active' : ''}
          aria-current={group.key === activeGroup ? 'page' : undefined}
          onPointerEnter={() => { void preloadRouteModule(group.defaultPath); }}
          onFocus={() => { void preloadRouteModule(group.defaultPath); }}
          onClick={() => {
            openTab(group.defaultPath);
            navigate(group.defaultPath);
          }}
        >
          {group.icon}
          <span>{t(group.titleKey)}</span>
        </button>
      ))}
    </nav>
  );
}
